import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import useIsMobile from '../hooks/useIsMobile'

const emptyForm = { name:'', addr:'', tel:'', fax:'', memo:'' }

export default function Clients() {
  const [list, setList] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editingId, setEditingId] = useState(null)
  const [form, setForm] = useState(emptyForm)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const isMobile = useIsMobile()

  useEffect(() => { fetchList() }, [])

  async function fetchList() {
    const { data, error } = await supabase.from('clients').select('*').order('name')
    if (error) console.error('clients 조회:', error.message)
    if (data) setList(data)
  }

  function openNewModal() {
    setEditingId(null)
    setForm(emptyForm)
    setShowModal(true)
  }

  function openEditModal(c) {
    setEditingId(c.id)
    setForm({ name: c.name || '', addr: c.addr || '', tel: c.tel || '', fax: c.fax || '', memo: c.memo || '' })
    setShowModal(true)
  }

  async function submitClient() {
    if (!form.name.trim()) { alert('상호를 입력하세요'); return }
    setLoading(true)
    const payload = { name: form.name.trim(), addr: form.addr, tel: form.tel, fax: form.fax, memo: form.memo }
    const q = editingId
      ? supabase.from('clients').update(payload).eq('id', editingId)
      : supabase.from('clients').insert(payload)
    const { error } = await q
    if (error) {
      const msg = error.message?.includes('duplicate') ? '이미 등록된 상호입니다' : error.message
      alert('저장 실패: ' + msg + '\n\nSupabase에 clients 테이블이 있는지 확인하세요 (supabase/sql/clients.sql 실행)')
      setLoading(false)
      return
    }
    setShowModal(false)
    fetchList()
    setLoading(false)
  }

  async function deleteClient(c) {
    if (!window.confirm(`${c.name} 거래처를 삭제할까요?\n(이미 작성된 문서는 영향 없습니다)`)) return
    const { error } = await supabase.from('clients').delete().eq('id', c.id)
    if (error) { alert('삭제 실패: ' + error.message); return }
    fetchList()
  }

  const filtered = list.filter(c => {
    const q = search.toLowerCase()
    if (!q) return true
    return c.name?.toLowerCase().includes(q) || c.addr?.toLowerCase().includes(q) || c.tel?.includes(q)
  })

  const inputStyle = { width:'100%', padding:'9px 12px', border:'1px solid #e5e3de', borderRadius:8, fontSize:13, fontFamily:'inherit', boxSizing:'border-box' }
  const labelStyle = { display:'block', fontSize:12, fontWeight:600, color:'#6b6860', marginBottom:6 }

  return (
    <div>
      {/* 헤더 */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20, flexWrap:'wrap', gap:10 }}>
        <div>
          <div style={{ fontSize:18, fontWeight:700, marginBottom:4 }}>거래처 관리</div>
          <div style={{ fontSize:13, color:'#a09e99' }}>거래명세표·발주서·견적서 작성 시 자동 입력 · 문서 저장 시 새 거래처 자동 등록</div>
        </div>
        <button onClick={openNewModal}
          style={{ padding:'8px 16px', borderRadius:8, border:'none', background:'#2d5a3d', color:'#fff', cursor:'pointer', fontSize:13, fontWeight:500 }}>
          + 거래처 등록
        </button>
      </div>

      {/* 검색 */}
      <div style={{ marginBottom:20 }}>
        <input value={search} onChange={e => setSearch(e.target.value)}
          placeholder="상호, 주소, 전화 검색..."
          style={inputStyle} />
      </div>

      {/* 목록 */}
      {isMobile ? (
        filtered.length === 0 ? (
          <div style={{ background:'#fff', border:'1px solid #e5e3de', borderRadius:10, textAlign:'center', padding:40, color:'#a09e99', fontSize:13 }}>
            등록된 거래처가 없습니다
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {filtered.map(c => (
              <div key={c.id} style={{ background:'#fff', border:'1px solid #e5e3de', borderRadius:10, padding:14, boxShadow:'0 1px 3px rgba(0,0,0,0.06)' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6, gap:8 }}>
                  <span style={{ fontSize:14, fontWeight:700 }}>{c.name}</span>
                  <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                    <button onClick={() => openEditModal(c)}
                      style={{ padding:'4px 10px', border:'1px solid #e5e3de', borderRadius:6, background:'#fff', cursor:'pointer', fontSize:12 }}>수정</button>
                    <button onClick={() => deleteClient(c)}
                      style={{ padding:'4px 10px', border:'none', borderRadius:6, background:'#fdeaea', color:'#b83030', cursor:'pointer', fontSize:12 }}>삭제</button>
                  </div>
                </div>
                {c.addr && <div style={{ fontSize:12, color:'#6b6860', marginBottom:3 }}>{c.addr}</div>}
                <div style={{ fontSize:12, color:'#6b6860' }}>
                  {c.tel && <span>☎ {c.tel}</span>}
                  {c.fax && <span style={{ marginLeft:10 }}>Fax {c.fax}</span>}
                </div>
                {c.memo && <div style={{ fontSize:11, color:'#a09e99', marginTop:4 }}>{c.memo}</div>}
              </div>
            ))}
          </div>
        )
      ) : (
      <div style={{ background:'#fff', border:'1px solid #e5e3de', borderRadius:10, overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              {['상호','주소','전화','팩스','비고',''].map((h, i) => (
                <th key={i} style={{ padding:'10px 14px', fontSize:11, fontWeight:600, color:'#a09e99', borderBottom:'1px solid #e5e3de', background:'#f9f8f6', textAlign:'left', whiteSpace:'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign:'center', padding:40, color:'#a09e99' }}>등록된 거래처가 없습니다</td></tr>
            ) : filtered.map(c => (
              <tr key={c.id} style={{ borderBottom:'1px solid #e5e3de' }}>
                <td style={{ padding:'12px 14px', fontWeight:600 }}>{c.name}</td>
                <td style={{ padding:'12px 14px', fontSize:12, color:'#6b6860', maxWidth:240, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.addr}</td>
                <td style={{ padding:'12px 14px', fontSize:12, color:'#6b6860', whiteSpace:'nowrap' }}>{c.tel}</td>
                <td style={{ padding:'12px 14px', fontSize:12, color:'#6b6860', whiteSpace:'nowrap' }}>{c.fax}</td>
                <td style={{ padding:'12px 14px', fontSize:12, color:'#a09e99', maxWidth:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.memo}</td>
                <td style={{ padding:'12px 14px' }}>
                  <div style={{ display:'flex', gap:6 }}>
                    <button onClick={() => openEditModal(c)}
                      style={{ padding:'4px 10px', border:'1px solid #e5e3de', borderRadius:6, background:'#fff', cursor:'pointer', fontSize:12 }}>수정</button>
                    <button onClick={() => deleteClient(c)}
                      style={{ padding:'4px 10px', border:'none', borderRadius:6, background:'#fdeaea', color:'#b83030', cursor:'pointer', fontSize:12 }}>삭제</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      )}

      {/* 등록/수정 모달 */}
      {showModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }}
          onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div style={{ background:'#fff', borderRadius:14, width:440, maxWidth:'95vw', boxShadow:'0 20px 60px rgba(0,0,0,0.15)' }}>
            <div style={{ padding:'20px 24px 16px', borderBottom:'1px solid #e5e3de', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:15, fontWeight:700 }}>{editingId ? '거래처 수정' : '거래처 등록'}</span>
              <button onClick={() => setShowModal(false)} style={{ border:'none', background:'#f9f8f6', borderRadius:6, width:28, height:28, cursor:'pointer', fontSize:16 }}>✕</button>
            </div>
            <div style={{ padding:'20px 24px' }}>
              <div style={{ marginBottom:14 }}>
                <label style={labelStyle}>상호 *</label>
                <input value={form.name} onChange={e => setForm({...form, name:e.target.value})} placeholder="예) ○○상사" style={inputStyle} />
              </div>
              <div style={{ marginBottom:14 }}>
                <label style={labelStyle}>주소</label>
                <input value={form.addr} onChange={e => setForm({...form, addr:e.target.value})} placeholder="사업장 주소" style={inputStyle} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
                <div>
                  <label style={labelStyle}>전화</label>
                  <input value={form.tel} onChange={e => setForm({...form, tel:e.target.value})} placeholder="000-0000-0000" style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>팩스</label>
                  <input value={form.fax} onChange={e => setForm({...form, fax:e.target.value})} placeholder="000-0000-0000" style={inputStyle} />
                </div>
              </div>
              <div>
                <label style={labelStyle}>비고</label>
                <input value={form.memo} onChange={e => setForm({...form, memo:e.target.value})} placeholder="담당자, 특이사항 등" style={inputStyle} />
              </div>
            </div>
            <div style={{ padding:'16px 24px', borderTop:'1px solid #e5e3de', display:'flex', gap:10, justifyContent:'flex-end' }}>
              <button onClick={() => setShowModal(false)}
                style={{ padding:'8px 16px', border:'1px solid #e5e3de', borderRadius:8, background:'#fff', cursor:'pointer', fontSize:13 }}>취소</button>
              <button onClick={submitClient} disabled={loading}
                style={{ padding:'8px 16px', border:'none', borderRadius:8, background:'#2d5a3d', color:'#fff', cursor:'pointer', fontSize:13, fontWeight:500 }}>
                {loading ? '저장 중...' : '저장하기'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
